import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TeamRoutingModule } from './team-routing.module';
import { TeamComponent } from './components/team/team.component';
import { WorkWithKettoComponent } from './components/work-with-ketto/work-with-ketto.component';
import { ReasonsToLoveKettoComponent } from './components/reasons-to-love-ketto/reasons-to-love-ketto.component';
import { LifeAtKettoComponent } from './components/life-at-ketto/life-at-ketto.component';
import { KnowMoreAboutUsComponent } from './components/know-more-about-us/know-more-about-us.component';
import { SubmitResumeComponent } from './components/submit-resume/submit-resume.component';
import { MeetTheTeamComponent } from './components/meet-the-team/meet-the-team.component';
import { NgxGlideModule } from 'ngx-glide';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [TeamComponent, WorkWithKettoComponent,
    ReasonsToLoveKettoComponent, LifeAtKettoComponent,
    KnowMoreAboutUsComponent, SubmitResumeComponent,
    MeetTheTeamComponent],
  imports: [
    CommonModule,
    TeamRoutingModule,
    NgxGlideModule,
    MatButtonModule
  ],
  exports: [TeamComponent]
})
export class TeamModule { }
